import { useEffect } from 'react';

/**
 * Custom hook to lock/unlock body scroll when modal is open/closed
 * @param {boolean} isLocked - Whether the body scroll should be locked
 */
const useBodyScrollLock = (isLocked) => {
  useEffect(() => {
    if (isLocked) {
      // Lock scroll
      document.body.style.overflow = 'hidden';
    } else {
      // Unlock scroll
      document.body.style.overflow = 'unset';
    }

    // Cleanup function - always unlock on unmount
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isLocked]);
};

export default useBodyScrollLock;
